import React, { useMemo, useCallback, FC } from "react";
import { sortBy, isEqual } from "lodash";
import { MultiSelectOption, IncMultiSelect } from "../CheckboxMultiSelect/MultiSelect";
import { FBarData } from "./types";

type Props = {
  filterData: FBarData[];
  onFilter?: (nFilterSelection: string[]) => void;
  selectedValues?: string[];
  label: string;
};

export const BarFilters: FC<Props> = props => {
  const { filterData, onFilter, selectedValues, label } = props;

  const options = useMemo<MultiSelectOption[]>(() => {
    let options = filterData.map(datum => {
      const { label, size, key } = datum;

      const value = key;

      return {
        label,
        value,
        meta: size.toString()
      };
    });
    options = sortBy(options, "label");
    return options;
  }, [filterData]);

  const onFilterChange = useCallback(
    (options: MultiSelectOption[]) => {
      const nSelection: string[] = options.map(option => option.value);
      const pSelection = selectedValues || [];

      const sortedNSelection = sortBy(nSelection);
      const sortedPSelection = sortBy(pSelection);

      const hasChanged = !isEqual(sortedNSelection, sortedPSelection);
      if (onFilter && hasChanged) {
        onFilter(nSelection);
      }
    },
    [onFilter, selectedValues]
  );

  const selectedOptions = useMemo(
    () => options.filter(opt => selectedValues?.includes(opt.value)),
    [options, selectedValues]
  );

  return (
    <IncMultiSelect
      hideLabel
      label={label}
      menuAsPortal
      noSelectText="Filter"
      onSelectChange={onFilterChange as any}
      options={options}
      showPlaceholder
      value={selectedOptions as MultiSelectOption[]}
    />
  );
};
